export function isPushApiSupported(): boolean {
  return (
    typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window
  );
}

export function isPwaStandalone(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const displayModeStandalone = window.matchMedia?.('(display-mode: standalone)').matches;
  const iosStandalone = Boolean((window.navigator as Navigator & { standalone?: boolean }).standalone);

  return displayModeStandalone || iosStandalone;
}

export function isIosDevice(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent ?? '';
  const isIpadOs = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

  return /iPad|iPhone|iPod/.test(userAgent) || isIpadOs;
}

export function canEnablePushNotifications(): boolean {
  if (!isPushApiSupported()) {
    return false;
  }

  if (isIosDevice() && !isPwaStandalone()) {
    return false;
  }

  return true;
}

export function getNotificationPermission(): NotificationPermission | null {
  if (typeof Notification === 'undefined') {
    return null;
  }

  return Notification.permission;
}

export function isPushPermissionDenied(): boolean {
  return getNotificationPermission() === 'denied';
}

export function isPushPermissionDefault(): boolean {
  return getNotificationPermission() === 'default';
}

export function detectPushPlatform(): 'ios' | 'android' | 'desktop' {
  if (typeof navigator === 'undefined') {
    return 'desktop';
  }

  if (isIosDevice()) {
    return 'ios';
  }

  const userAgent = navigator.userAgent ?? '';
  if (/Android/i.test(userAgent)) {
    return 'android';
  }

  return 'desktop';
}
